/**
 * The note detail page's content-column width (#14933).
 *
 * ONE value read by two places that must agree: the column on
 * `src/app/notes/[id]/page.tsx`, and the floating recording bar, whose
 * overall width is capped at it (`RECORDING_BAR_MAX_WIDTH`). It used to be the
 * page's `max-w-3xl` class, and a bar cap written as a second literal would
 * have drifted the first time either moved.
 *
 * 64rem — `max-w-5xl`, the design pass's detail column and a priority
 * page's (#16749) — kept in rem so the column still scales with a reader's
 * font size.
 */
export const NOTE_CONTENT_MAX_WIDTH = '64rem'
